import { CountryFilter } from "@tm/models"
import { VrcLookupModule } from "../data/model/vrc-lookup"

export function isVrcModuleUsingKbaNumbers(module: VrcLookupModule) {
    return module.binLkz === CountryFilter.D
}
